export default __webpack_public_path__ + "static/media/img5.84cf9f82.jpg";